import React from "react";
// css
import "./Discover.css";

// DISCOVER {{HOME COMPONENT}}
const Discover = () => {
  return (
    <>
      <section className="discover">
        <div className="discover_content pt-5 mt-5 mb-5 pb-5">
          <h1>Zakynthos</h1>
          <p>Greek Island</p>
          <button className="discover_btn">DISCOVER</button>
        </div>
      </section>
    </>
  );
};

export default Discover;
